import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "@/helpers/axios";
import type { ApiResponse } from "@/helpers/axios";
import type { ApiDevice } from "../_types/devices.types";

export type UpdateDevicePayload = {
  name?: string;
  location?: string | null;
  organization?: string | null;
  assignedTo?: string | null;
  notes?: string | null;
  deviceProfileId?: string | null;
  deviceBrandingId?: string | null;
};

export const useUpdateDeviceMutation = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (payload: { id: string; patch: UpdateDevicePayload }) => {
      const res = await axiosInstance.put<ApiResponse<ApiDevice>>(`/v2/devices/${payload.id}`, payload.patch);
      if (!res.data.success || !res.data.data) throw new Error(res.data.message ?? "Failed");
      return res.data.data;
    },
    onSuccess: (_data, variables) => {
      qc.invalidateQueries({ queryKey: ["devices"] });
      qc.invalidateQueries({ queryKey: ["device", variables.id] });
    },
  });
};
